import * as Sentry from "@sentry/react";
import { useEffect } from "react";

import { safeJsonParse } from "../components/global/JsonHelper";

export default function SentryUserTracker() {
  useEffect(() => {
    try {
      let user = null;

      const candidates = ["user", "authUser", "currentUser"];
      for (const key of candidates) {
        const raw = localStorage.getItem(key);
        if (raw) {
          user = safeJsonParse(raw);
          break;
        }
      }

      if (user && (user.id || user.pk || user.email)) {
        Sentry.setUser({
          id: user?.id ?? user?.pk ?? undefined,
          email: user?.email ?? undefined,
          username: user?.name ?? user?.username ?? undefined,
        });
      } else {
        Sentry.setUser(null);
      }
    } catch {
      Sentry.setUser(null);
    }

    return () => {
      Sentry.setUser(null);
    };
  }, []);

  return null;
}
